import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import Head from 'next/head';
import openGraphDefaultImage from '@store/public/images/og/yohana.jpg';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Manages the SEO relevant tags on each page.
 *
 * @param title - page title.
 * @param description - page description.
 * @param keywords - keywords relevant to the page.
 */
export var SEO = function SEO(_ref) {
  var _og$image;

  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      og = _ref.og;

  var _useExternalConfig = useExternalConfig(),
      baseUrl = _useExternalConfig.baseUrl;

  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("meta", {
      property: "og:image",
      content: "".concat(baseUrl).concat((_og$image = og === null || og === void 0 ? void 0 : og.image) !== null && _og$image !== void 0 ? _og$image : openGraphDefaultImage.src)
    }, "og:image"), description && /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description
    }, "page-description"), keywords && /*#__PURE__*/_jsx("meta", {
      name: "keywords",
      content: _toConsumableArray(keywords).join(', ')
    }, "page-keywords"), title && /*#__PURE__*/_jsx("title", {
      children: title
    }, "page-title")]
  });
};
export default SEO;